import { Box, Svg, SvgBubble, Text, Tooltip } from '@hopskipdrive/react-components';

import { formatLocations } from '../../../hooks/useLocationOptions';
import { LocationAccordion, LocationAccordionSkeleton } from '../../components/LocationAccordion';

import { RiderAssistant, RiderAssistantTimelineItem, Timeline } from './Waypoints.styles';

export const RiderAssistantWaypoint = ({ num, rideLabel, location, type, riderAssistants }) => {
  return (
    <RiderAssistantTimelineItem
      dotContent={
        num === 1 ? (
          <Timeline.LocationDotWithActions num={num} onRemove={() => {}} disableAction={true} />
        ) : (
          <Timeline.NumberDotWithActions num={num} onRemove={() => {}} disableAction={true} />
        )
      }
      connector={<Timeline.SolidConnector />}
    >
      <div data-testid="ra-waypoint">
        <Box mb={5} display="flex" flexDirection="row" alignItems="center">
          <Text mr={4}>Rider Assistant {rideLabel}</Text>
          <Tooltip title="This waypoint is reserved for the Rider Assistant and can't be edited or rearranged.">
            <SvgBubble>
              <Svg icon="question" />
            </SvgBubble>
          </Tooltip>
        </Box>

        {riderAssistants?.length ? (
          riderAssistants.map((ra, index) => (
            <RiderAssistant key={index}>
              <span>RA</span>
              <div>
                {ra.firstName} {ra.lastName}
              </div>
            </RiderAssistant>
          ))
        ) : (
          <RiderAssistant>
            <span>RA</span>
            <div>Rider Assistant</div>
          </RiderAssistant>
        )}

        {location ? (
          <LocationAccordion
            waypointType={type}
            editMode={false}
            noEdit={true}
            location={location}
            locations={formatLocations([location])}
            hideInstructions={true}
          />
        ) : (
          <LocationAccordionSkeleton />
        )}
      </div>
    </RiderAssistantTimelineItem>
  );
};
